module.exports = __webpack_public_path__ + "img/foreward_4.3c062232.jpg";